export const appSettings = {
    saveGameEnabled: true,
    googleAds: false,
    statsEnabled: false,
    tubeRewardLevelsToPass: 3,
    soundOff: false,
    remainingStepsBack: 5,
    storageDays: 14
}